import { BOLD_GROUP } from "../actions/boldgroup/ActionType";

const initialState = {
  jobDetail: "",
  repairList: [],
  repairDetail: {
    repairIndex: 0,
    repairTypeID: 1,
    repairTypeName: "",
    markers: [],
    polylines: [],
  },
  mapCenter: {
    lat: 13.851285641909238,
    lng: 100.56217384788845,
  },
  coverageLayers: [],
  coverageRoutes: [],
  devicesOdfMdf: [
    {
      count_port: 12,
      portPairList:
        "1-2208250,2-2208251,3-2208252,4-2208253,5-2208254,6-2208255,7-2208256,8-2208257,9-2208258,10-2208259,11-2208260,12-2208261",
      obj_id: 177946,
      obj_type: "ODF",
      obj_label: "งามวงศ์วาน47แยก6",
      obj_idx_of_group: 1,
      obj_order_in_all_group: 1,
      obj_number_on_label: 0,
      portDetail: {
        "1-2208250": {
          fromPath: [2208250, 2208226, 2208238],
          portStatusFrom: "Full",
          toPath: [2208250, 0],
          portStatusTo: "Empty",
        },
        "2-2208251": {
          fromPath: [2208251, 2208227, 2208239],
          portStatusFrom: "Full",
          toPath: [2208251, 0],
          portStatusTo: "Empty",
        },
        "3-2208252": {
          fromPath: [2208252, 2208228, 2208240],
          portStatusFrom: "Full",
          toPath: [2208252, 0],
          portStatusTo: "Empty",
        },
        "4-2208253": {
          fromPath: [2208253, 2208229, 2208241],
          portStatusFrom: "Full",
          toPath: [2208253, 0],
          portStatusTo: "Empty",
        },
        "5-2208254": {
          fromPath: [2208254, 2208230, 2208242],
          portStatusFrom: "Full",
          toPath: [2208254, 0],
          portStatusTo: "Empty",
        },
        "6-2208255": {
          fromPath: [2208255, 2208231, 2208243],
          portStatusFrom: "Full",
          toPath: [2208255, 0],
          portStatusTo: "Empty",
        },
        "7-2208256": {
          fromPath: [2208256, 2208232, 2208244],
          portStatusFrom: "Full",
          toPath: [2208256, 0],
          portStatusTo: "Empty",
        },
        "8-2208257": {
          fromPath: [2208257, 2208233, 2208245],
          portStatusFrom: "Full",
          toPath: [2208257, 0],
          portStatusTo: "Empty",
        },
        "9-2208258": {
          fromPath: [2208258, 2208234, 2208246],
          portStatusFrom: "Full",
          toPath: [2208258, 0],
          portStatusTo: "Empty",
        },
        "10-2208259": {
          fromPath: [2208259, 2208235, 2208247],
          portStatusFrom: "Full",
          toPath: [2208259, 0],
          portStatusTo: "Empty",
        },
        "11-2208260": {
          fromPath: [2208260, 2208236, 2208248],
          portStatusFrom: "Full",
          toPath: [2208260, 0],
          portStatusTo: "Empty",
        },
        "12-2208261": {
          fromPath: [2208261, 2208237, 2208249],
          portStatusFrom: "Full",
          toPath: [2208261, 0],
          portStatusTo: "Empty",
        },
      },
      emptyPortFrom: [],
      fullPortFrom: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      emptyPortTo: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      fullPortTo: [],
    },
    {
      count_port: 12,
      portPairList:
        "1-2131615,2-2131616,3-2131617,4-2131618,5-2131619,6-2131620,7-2131621,8-2131622,9-2131623,10-2131624,11-2131625,12-2131626",
      obj_id: 172087,
      obj_type: "ODF",
      obj_label: "ซอยชินเขต1",
      obj_idx_of_group: 1,
      obj_order_in_all_group: 2,
      obj_number_on_label: 0,
      portDetail: {
        "1-2131615": {
          fromPath: [2131615, 2131591, 2131603],
          portStatusFrom: "Full",
          toPath: [2131615, 0],
          portStatusTo: "Empty",
        },
        "2-2131616": {
          fromPath: [2131616, 2131592, 2131604],
          portStatusFrom: "Full",
          toPath: [2131616, 0],
          portStatusTo: "Empty",
        },
        "3-2131617": {
          fromPath: [2131617, 2131593, 2131605],
          portStatusFrom: "Full",
          toPath: [2131617, 0],
          portStatusTo: "Empty",
        },
        "4-2131618": {
          fromPath: [2131618, 2131594, 2131606],
          portStatusFrom: "Full",
          toPath: [2131618, 0],
          portStatusTo: "Empty",
        },
        "5-2131619": {
          fromPath: [2131619, 2131595, 2131607],
          portStatusFrom: "Full",
          toPath: [2131619, 0],
          portStatusTo: "Empty",
        },
        "6-2131620": {
          fromPath: [2131620, 2131596, 2131608],
          portStatusFrom: "Full",
          toPath: [2131620, 0],
          portStatusTo: "Empty",
        },
        "7-2131621": {
          fromPath: [2131621, 2131597, 2131609],
          portStatusFrom: "Full",
          toPath: [2131621, 0],
          portStatusTo: "Empty",
        },
        "8-2131622": {
          fromPath: [2131622, 2131598, 2131610],
          portStatusFrom: "Full",
          toPath: [2131622, 0],
          portStatusTo: "Empty",
        },
        "9-2131623": {
          fromPath: [2131623, 2131599, 2131611],
          portStatusFrom: "Full",
          toPath: [2131623, 0],
          portStatusTo: "Empty",
        },
        "10-2131624": {
          fromPath: [2131624, 2131600, 2131612],
          portStatusFrom: "Full",
          toPath: [2131624, 0],
          portStatusTo: "Empty",
        },
        "11-2131625": {
          fromPath: [2131625, 2131601, 2131613],
          portStatusFrom: "Full",
          toPath: [2131625, 0],
          portStatusTo: "Empty",
        },
        "12-2131626": {
          fromPath: [2131626, 2131602, 2131614],
          portStatusFrom: "Full",
          toPath: [2131626, 0],
          portStatusTo: "Empty",
        },
      },
      emptyPortFrom: [],
      fullPortFrom: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      emptyPortTo: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      fullPortTo: [],
    },
  ],
};

const repairPointReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case BOLD_GROUP.SET_REPAIR_LIST:
      return {
        ...state,
        repairList: payload,
      };
    case BOLD_GROUP.SET_REPAIR_DETAIL:
      return {
        ...state,
        repairDetail: payload,
      };

    case BOLD_GROUP.CLEAR_REPAIR_DETAIL:
      return {
        ...state,
        repairDetail: initialState.repairDetail,
      };

    case BOLD_GROUP.CLEAR_REPAIR_POINT:
      return {
        ...state,
        repairList: [
          {
            repairTypeID: 1,
            repairTypeName: "STRADDLE",
            markers: [],
            polylines: [],
          },
        ],
      };

    case BOLD_GROUP.SET_REPAIR_JOB_DETAIL:
      return {
        ...state,
        jobDetail: payload,
      };

    case BOLD_GROUP.SET_CENTER_MAP:
      return {
        ...state,
        mapCenter: payload,
      };

    case BOLD_GROUP.SET_COVERAGE:
      return {
        ...state,
        coverageLayers: payload,
      };
    case BOLD_GROUP.SET_COVERAGE_ROUTE:
      return {
        ...state,
        coverageRoutes: payload,
      };

    case BOLD_GROUP.SET_ACCESSORY_ODF_MDF:
      return {
        ...state,
        devicesOdfMdf: payload,
      };

    default:
      return state;
  }
};

export default repairPointReducer;
